export default __webpack_public_path__ + "static/item_02-42426f152f23945b3ee050fb257e187a.jpg";